import React from 'react';

const Menu = ({ className }) => (
  <svg className={className} fill='none' viewBox='0 0 24 24'>
    <path
      fill='currentColor'
      d='M21.25,15.75 C21.9403559,15.75 22.5,16.3096441 22.5,17 C22.5,17.6472087 22.0081253,18.1795339 21.3778052,18.2435464 L21.25,18.25 L1.25,18.25 C0.559644063,18.25 0,17.6903559 0,17 C0,16.3527913 0.491874664,15.8204661 1.12219476,15.7564536 L1.25,15.75 L21.25,15.75 Z M21.25,7.75 C21.9403559,7.75 22.5,8.30964406 22.5,9 C22.5,9.64720869 22.0081253,10.1795339 21.3778052,10.2435464 L21.25,10.25 L1.25,10.25 C0.559644063,10.25 0,9.69035594 0,9 C0,8.35279131 0.491874664,7.8204661 1.12219476,7.75645361 L1.25,7.75 L21.25,7.75 Z M21.25,0 C21.9403559,0 22.5,0.559644063 22.5,1.25 C22.5,1.89720869 22.0081253,2.4295339 21.3778052,2.49354639 L21.25,2.5 L1.25,2.5 C0.559644063,2.5 0,1.94035594 0,1.25 C0,0.602791309 0.491874664,0.0704661011 1.12219476,0.00645360909 L1.25,0 L21.25,0 Z'
    ></path>
  </svg>
);

export default Menu;
